module.exports = __webpack_public_path__ + "media/images/categories/color/apartment-c283fe95f6a0f3830281109c1b67b468.png";